import { ENUM__connection_state } from '@/enums/ENUM__connection_state';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_app_info, use_slice_network, use_slice_user } from '@/hooks/store/use_slices';
import { service_socketio_client } from '@/services/socketio_client_react/service_socketio_client';
import { LOCAL__global_reset } from '@/state/_base/LOCAL__global_reset';
import { LOCAL__user_auth_logout } from '@/state/user/auth/LOCAL__user_auth_logout';
import { remote_user_auth_login_with_token } from '@/state/user/auth/login/remote_user_auth_login_with_token';
import { DTO_RESPONSE__auth_success } from '@shared/dto/+user/auth/_requests/response_auth_success';
import { ELoggerNamespaceShared } from '@shared/logger/e_logger_namespace_shared';
import { ENetworkEventClientOnly } from '@shared/network/ENetworkEventClientOnly';
import { logi } from '@shared/utils/utils_logs';
import { useRef } from 'react';

export function WatcherLoginWithToken() {
  const dispatch = use_dispatch();

  const { auth_token } = use_slice_user(['auth_token']);
  const { state } = use_slice_network(['state']);
  const { app_info, is_app_reloading } = use_slice_app_info(['app_info', 'is_app_reloading']);

  const is_authorizing = useRef(false);

  /*
   * EFFECTS
   */

  use_effect(() => {
    void try_login_with_token();
  }, [auth_token, state, app_info, is_app_reloading]);

  use_effect(() => {
    service_socketio_client.socket?.on(ENetworkEventClientOnly.RECONNECT, onReconnect);

    return () => void service_socketio_client.socket?.off(ENetworkEventClientOnly.RECONNECT, onReconnect);
  }, []);

  /*
   * EVENTS
   */
  async function onReconnect() {
    logi('socket reconnected, attempting to reauthorize', { namespace: ELoggerNamespaceShared.CLIENT_TO_SERVER });

    await try_login_with_token();
  }

  /*
   * METHODS
   */

  async function try_login_with_token() {
    if (!auth_token) return; //not contains token to login with
    if (state != ENUM__connection_state.CONNECTION_ESTABLISHED) return; //not connected
    if (is_authorizing.current) return; //in progress
    if (service_socketio_client.is_connection_authorized) return; //already authorized
    if (app_info.is_stub()) return; //doesnt receive app info yet
    if (app_info.is_maintenance_mode_enabled()) return; //maintenance mode enabled
    if (is_app_reloading) return; //app reloading after maintenance, no need to authorize

    is_authorizing.current = true;

    let action_result = await dispatch(remote_user_auth_login_with_token(auth_token));

    if (!(action_result.payload instanceof DTO_RESPONSE__auth_success)) {
      dispatch(LOCAL__global_reset());

      dispatch(LOCAL__user_auth_logout());
    }

    is_authorizing.current = false;
  }

  return <></>;
}
